<div class="col-xs-12 modify-title">
  <span class="icon icon-arrow-left"></span>
  <p class="text-10-m-demibold">TODOS LOS PASOS</p>
  <div class="hidden-xs hidden-sm sticky fade-out-shadow" [class.hidden]="isSectionHasError()">
    <span class="icon icon-cancel modal-trigger" data-trigger-modal="modal-example-update-results" (click)="openDiscard()"></span>
    <button class="btn solid-main btn-update-results" (click)="submit()" [class.hidden]="!isFormModified()">Actualizar resultados</button>
  </div>
  <div class="go-section desktop" id="ErrorDiv" [class.hidden]="!isSectionHasError()">
    <img src="{{ baseImageUrl }}cj/ws/icon-alert.svg" class="icon icon-alert" aria-hidden="true" alt="alert-icon">
    <span class="message text-09-m-demibold text-13-d-demibold"
      >Por favor, completa las preguntas del <span class="step" id="Step">Paso {{ sectionErrorIndexes }}</span> para continuar</span
    >
  </div>
  <span class="icon icon-cancel hidden-lg hidden-md modal-trigger" data-trigger-modal="modal-example-update-results" (click)="openDiscard()"></span>
</div>
